module.exports = __webpack_public_path__ + "static/media/photo.d21068b3.png";